import React from "react";
import { useNavigate } from "react-router-dom";
import picture from "../../../../../Assets/Images/Validation_1.gif"
import { useDispatch } from "react-redux";
import { RESET_COURSE_DECLARATION_INFO } from "../../../../../Redux/Reducers/DeclarationCourseReducers";
// import IndexStep from "../../../../..";
import Client from "../../../../../Objects/models/Client";
import { CourseType, courseTypes } from "../../staticData";
import IndexStep from "../../../../../App/DeclarationCourse/IndexStep";

type Props = {
	client?: Client;
	generalStep: any;
	handleChangeStep: (val: number) => void;
}

export default function FinalStep({ generalStep, client }: Props) {
	const dispatch = useDispatch();
	const navigate = useNavigate()
	const courseType = generalStep?.courseType as CourseType

	const handleNext = async () => {
		navigate("/user/dashboard", { state: 1 })
		dispatch({
			type: RESET_COURSE_DECLARATION_INFO,
			payload: null,
		});
	}

	const displayBody = () => {
		return (
			<div className="flex items-center overflow-hidden mt-6">
				<div className=' hidden  md:block w-1/2 '>
					<img src={picture} alt="GIF de validation" />
				</div>
				<div className=" md:w-1/2  space-y-2">
					<div className="space-y-8 lg:text-lg md:text-lg text-base">
						<p>
							Félicitations {client?.firstName} ! Votre demande de cours a été créée avec succès.
							Elle est désormais disponible sur votre tableau de bord, prête à être consultée et gérée.
							Vous pouvez dès à présent y accéder pour voir les professeurs intéressés par votre offre.
							Merci de votre confiance et bon cours !
						</p>
						<img src={picture} alt="GIF de validation" className="md:hidden" />
						<button onClick={handleNext} className="py-2 z-50 font-extrabold text-white w-full uppercase rounded-full text-xs bg-first">
							Tableau de bord
						</button>
					</div>
					{/* } */}
				</div>
			</div>
		)
	}

	return <IndexStep
		title={`Félicitations, déclaration de ${courseTypes[courseType].toLowerCase()} validée ! 🥳`}
		body={displayBody()}
		isHere={true}
		value={6}
		step={5}
		handleNexStep={handleNext}
		generalStep={generalStep}
	/>

};